module.exports = __webpack_public_path__ + "static/media/instagram-icon.fa970dc2.svg";